import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useAppSelector, useFetchCutOffTime } from '../../../../hooks/redux';
import CutOffTimeList from './components/CutOffTimeList';
import AddEditCutOffTime from './components/AddEditCutOffTime';
import { TState } from '../../types';
import { EChangeCutOffTime } from './types';
import css from './CutOffTime.module.scss';

type TCutOffTime = {
  setState: React.Dispatch<React.SetStateAction<TState>>;
};

export const CutOffTime = ({ setState }: TCutOffTime) => {
  useFetchCutOffTime()
  
  const [state, setChangeState] = useState<EChangeCutOffTime>(EChangeCutOffTime.LIST);
  const { loading } = useAppSelector((state) => state.cutOffTimeReducer);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <section className={css.root}>
      <div className={css.title}>Cut-off Time</div>
      {state === EChangeCutOffTime.LIST && <CutOffTimeList setState={setState} setChangeState={setChangeState} />}
      {[EChangeCutOffTime.ADD, EChangeCutOffTime.EDIT].includes(state) && <AddEditCutOffTime setChangeState={setChangeState} />}
    </section>
  );
};
